module.exports = __webpack_public_path__ + "static/media/AIA_main@2x.4fbf1704.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/aia/AIA_main@2x.png
// module id = 182
// module chunks = 0